import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=9e431eec&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e431eec')) {
      api.createRecord('9e431eec', component.options)
    } else {
      api.reload('9e431eec', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=9e431eec&", function () {
      api.rerender('9e431eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/partials/Sidebar.vue"
export default component.exports